export default function debounce(fn: (...args: any[]) => void, wait: number = 250, immediate: boolean = false): (...args: any[]) => void {
  let timeout: NodeJS.Timeout | null;

  return function (this: void, ...args: any[]): void {
    const context = this;

    const later = () => {
      timeout = null;
      if (!immediate) {
        fn.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout!);

    timeout = setTimeout(later, wait);

    if (callNow) {
      fn.apply(context, args);
    }
  };
}